










































































































































































































































































































































































































import Vue from 'vue'
import QualityLabel from '@/components/QualityLabel'
import CasterStatus from '@/components/CasterStatus'
import VideoPlaceholder from '@/components/VideoPlaceholder'
import InputOutputStatus from '@/components/InputOutputStatus'
import ChatComponent from '@/components/ChatComponent'
import FinalOutputPlayer from '@/components/FinalOutputPlayer'
import CrewStatus from './CrewStatus'
import ClipMaker from '@/components/Clipper/ClipMaker'
import ClipOverview from '@/components/Clipper/ClipOverview'
import CreateEditCastTemplate from '@/components/CreateEditCastTemplate'
import Modal from '@/components/Modal'
import { Popover, Button } from 'element-ui'
import fb from '@/firebase'
import moment from 'moment'
import { UserNotification, UserProfile } from '@/types/users'
import { KeyDict } from '@/types'
import { CallTriage, Cast, CastChatMessage, CompositeOutputStream, InvitedCaster } from '@/types/casts'
import { SystemStatus } from '@/types/ops'
import { SourceStream, Stream, StreamType } from '@/types/streams'
import { isMobile } from 'mobile-device-detect'
import { findKey } from 'lodash'
import { WATERMARK_DEFAULT } from '@/store/types'
import CastSupportBadge from '@/components/CastSupportBadge/CastSupportBadge.vue'
import CastEnvBadge from '@/components/CastEnvBadge/CastEnvBadge.vue'
import CastBadge from '@/components/CastBadge'
import helpers from '@/helpers'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { pickBy } from 'lodash'
import { TeamGroup } from '@/types/teams'

export default Vue.extend({
  name: 'SingleCast',
  props: {
    cast: {
      type: Object as () => Cast,
      required: true
    },
    teamStreams: {
      type: Object as () => KeyDict<Stream>
    },
    streamsManager: {
      type: Object
    },
    currentUserId: {
      type: String
    },
    currentTeam: {
      type: Array as () => UserProfile[]
    },
    castAudioActive: {
      type: String
    },
    audioActivated: {
      type: Boolean
    },
    copiesExist: {
      type: Boolean
    },
    mode: {
      type: String,
      default: 'active'
    },
    showIntro: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMobile () {
      return isMobile // any mobile device including tablets
    },
    // permissions in component instead of view for unit testing purposes
    canCopyCast (): boolean {
      return this.$can(AbilityAction.Copy, AbilitySubject.Cast)
    },
    canCreateCastCastTemplate (): boolean {
      return this.$can(AbilityAction.Create, AbilitySubject.CastTemplates)
    },
    canEditCast (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.Cast)
    },
    canDeleteCast (): boolean {
      return this.$can(AbilityAction.Delete, AbilitySubject.Cast)
    },
    canNotifyCaster (): boolean {
      return this.$can(AbilityAction.Notify, AbilitySubject.Cast)
    },
    muteStatus (): boolean {
      return this.castAudioActive !== this.cast.id
    },
    invitedCasters (): KeyDict<InvitedCaster> | null {
      let invitedCasters: KeyDict<InvitedCaster> | null = null
      if (this.cast.invited_casters && Object.keys(this.cast.invited_casters).length > 0) {
        invitedCasters = this.cast.invited_casters
      }
      return invitedCasters
    },
    hasVisibleCasters (): boolean {
      return Object.keys(this.visibleCasters).length > 0
    },
    visibleCasters (): KeyDict<InvitedCaster> {
      return pickBy(this.invitedCasters ?? {}, (caster) => {
        const profile = this.currentTeam?.find((user) => user.id === caster.userId)
        if (profile?.assignedId) return false
        return caster.triage === CallTriage.Accepted && !caster.deleted
      })
    },
    showCasterIntro (): boolean {
      return this.showIntro && this.hasStarted && this.isCaster
    },
    isCaster (): boolean {
      // this.currentUserId
      let isCaster = false
      if (this.cast.invited_casters && Object.keys(this.cast.invited_casters).length > 0) {
        isCaster = Object.keys(this.cast.invited_casters).some(k => k === this.currentUserId)
      }
      return isCaster
    },
    hasStarted (): boolean {
      return this.cast && this.cast.start_date && this.cast.start_date.seconds * 1000 < Date.now()
    },
    showOutputStreamReminder (): boolean {
      return this.isCopy && Object.keys(this.cast.custom_rtmp_destinations || {}).length === 0
    },
    isCopy (): boolean {
      return !!this.cast && !!this.cast.originalCast
    },
    presentCrew (): UserProfile[] {
      const crewArr: UserProfile[] = []
      const onlinePeople: KeyDict<string[]> = this.cast.online_sessions
      if (this.cast.invited_casters !== undefined) {
        for (const key in onlinePeople) {
          const caster = this.cast.invited_casters[key]
          if (onlinePeople[key].length > 0 && (!caster || caster.deleted)) {
            const teamMember = this.currentTeam.find((member: UserProfile) => { return member.user_id === key })
            if (teamMember) { crewArr.push(teamMember) }
          }
        }
      }
      return crewArr
    },
    finalOutputStream (): string {
      let stream = ''
      if (this.cast.hasOwnProperty('output_streams')) {
        if (this.cast.output_streams.hasOwnProperty('rtsplowres')) {
          if (this.cast.output_streams.rtsplowres.ngcvp_status === SystemStatus.OK) {
            stream = this.cast.output_streams.rtsplowres.stream
          }
        }
      }
      return stream
    },
    inputStreams (): KeyDict<Partial<SourceStream>> {
      const inputs: KeyDict<Partial<SourceStream>> = {}
      const sourceStreams = this.cast.source_streams
      for (const key in sourceStreams) {
        if (sourceStreams[key].type === StreamType.Broadcast) {
          let input = sourceStreams[key]
          input.connected = input.ngcvp_status === SystemStatus.OK
          input.start_time = input.start_time
          if (this.teamStreams.hasOwnProperty(key)) {
            if (this.teamStreams[key].name !== '') {
              input.name = this.teamStreams[key].name
            } else {
              if (this.teamStreams[key].user !== undefined) {
                const person = this.currentTeam.find(member => {
                  return member.user_id === this.teamStreams[key].user
                })
                if (person !== undefined) {
                  input.name = person.first_name
                } else {
                  input.name = 'Input Stream'
                }
              } else {
                input.name = 'Input Stream'
              }
            }
          }
          const teamStream = this.teamStreams[key] !== undefined ? this.teamStreams[key] : {}
          input = {...teamStream, ...input}
          inputs[key] = input
        }
      }
      return inputs
    },
    originalOutputStreams (): KeyDict<CompositeOutputStream> {
      return this.getOutputStreams(true)
    },
    outputStreams (): KeyDict<CompositeOutputStream> {
      return this.getOutputStreams()
    },
    castName (): string {
      let name = this.cast.name
      const eventName = this.getEventName() // TODO: Remove again once always cast==event
      if (eventName !== '' && eventName !== name) name = `${name} [${eventName}]`
      return name
    },
    teamGroups (): TeamGroup[] {
      return this.$store.direct.state.team.teamGroups ?? []
    },
    teamGroupsPopover (): string {
      const header: string = 'Only visible to these Member Groups:\n\n'
      const groupNames: string[] = []
      for (const groupId of this.cast.teamGroups) {
        //Only add names of groups that can be found
        const index = this.teamGroups.findIndex(group => group.id === groupId)
        if (index !== -1 && this.teamGroups[index].name) groupNames.push(this.teamGroups[index].name)
      }
      return header + groupNames.join(',\n')
    }
  },
  data: () => ({
    open: false,
    visible: true,
    messages: [] as CastChatMessage[],
    openclipper: false,
    videoduration: 0,
    unsubscribeChatFunction: null as Function |  null,
    showCreateCastTemplateModal: false,
    maxChars: 40
  }),
  mounted () {
    this.subscribeChatMessages()
    this.$emit('castLoaded')
  },
  destroyed () {
    this.unsubscribeChatMessages()
  },
  methods: {
    getURL (name, params): string {
      return helpers.getURL(this.$router, name, params)
    },
    getOutputStreams (fromOriginal = false): KeyDict<CompositeOutputStream> {
      const outputs: KeyDict<CompositeOutputStream> = {}
      let sourceCast = this.cast
      if (fromOriginal && this.cast.originalCast) {
        sourceCast = JSON.parse(this.cast.originalCast)
      }
      if (sourceCast.hasOwnProperty('custom_rtmp_destinations') && !!sourceCast.custom_rtmp_destinations) {
        Object.keys(sourceCast.custom_rtmp_destinations || {}).forEach( (streamname: string) => {
          const output: CompositeOutputStream = Object.assign({}, sourceCast.custom_rtmp_destinations![streamname])
          if (output.streamname === '') {
            output.streamname = streamname
          }
          if (!!sourceCast.output_streams && sourceCast.output_streams.hasOwnProperty(streamname)) {
            output.ngcvp_status = sourceCast.output_streams[streamname].ngcvp_status !== undefined ? sourceCast.output_streams[streamname].ngcvp_status : SystemStatus.NONE
            output.type = StreamType.Output
          }
          outputs[streamname] = output
        })
      }
      return outputs
    },
    needsNotification (casterId) {
      const castCopiesExist = this.copiesExist
      const is_present = this.cast.online_sessions
        && this.cast.online_sessions.hasOwnProperty(casterId)
        && this.cast.online_sessions[casterId].length > 0
      const is_casting = Object.values(this.cast.source_streams || [])
        .some( (sourceStream: Partial<SourceStream>) => {
          return sourceStream && sourceStream.user_id && sourceStream.user_id === casterId
        })
      const received_notification = this.receivedNotification(casterId)

      return castCopiesExist && !is_present && !is_casting &&!received_notification
    },
    receivedNotification (casterId) {
      const castLink = `/event/${this.cast.id}`
      const receivedNotification = this.$store.direct.getters.team.joinNotification(casterId, castLink)
      return !!receivedNotification
    },
    notifyCaster (casterId: string) {
      const notification = this.createNotification(casterId)
      this.$store.direct.dispatch.team.notifyTeamMember(notification)
        .then(() => {
          this.$message({
            type: 'success',
            message: `join request sent`
          })
        }).catch(error => {
          console.error('SingleCast.notifyCaster error ', error)
        })
    },
    createNotification (casterId: string): UserNotification {
      const notification = new UserNotification()
      notification.user_id = casterId
      notification.message = `Please join cast '${this.cast.name}'`
      notification.linkLabel = `Go to cast`
      notification.link = `/event/${this.cast.id}`
      return notification
    },
    undoNotifyCaster (casterId) {
      const castLink = `/event/${this.cast.id}`
      const receivedNotification = this.$store.direct.getters.team.joinNotification(casterId, castLink)
      if (!receivedNotification) {
        this.$message({
          type: 'error',
          message: `No join request found`
        })
      } else {
        this.$store.direct.dispatch.team.undoNotifyTeamMember(receivedNotification)
          .then(() => {
            this.$message({
              type: 'success',
              message: `Removed join request`
            })
          }).catch(error => {
            this.$message({
              type: 'error',
              message: `Could not remove join request`
            })
            console.error('undoNotifyCaster errors ', error)
          })
      }
    },
    goToCast () {
      const route = this.$router.resolve({ name: 'liveEvent', params: { id: this.cast.id } })
      window.location.href = route.href
    },
    startCreateCastTemplate () {
      this.showCreateCastTemplateModal = true
    },
    async saveCastTemplate (name: string) {
      const tmpTemplate: Cast = { ...this.cast }
      tmpTemplate.name = name
      tmpTemplate.watermark = WATERMARK_DEFAULT
      await this.$store.direct.dispatch.castTemplates.saveCastAsTemplate(tmpTemplate)
      this.$message({
        type: 'success',
        message: 'Event template has been saved'
      })
    },
    createClip (offsets) {
      const clipinfo = {
        cast: this.cast.id,
        k360event: this.cast.k360_event_id,
        start: offsets.from,
        end: offsets.to,
        name: offsets.name
      }
      this.$store.dispatch('events/makeClip', clipinfo)
    },
    deleteClip (clipId) {
      const data = {
        clipid: clipId,
        cast: this.cast.id
      }
      this.$store.dispatch('events/deleteClip', data)
    },
    clipInfoUpdated (videoduration) {
      this.videoduration = videoduration
    },
    unsubscribeChatMessages () {
      if (this.unsubscribeChatFunction !== null) {
        this.unsubscribeChatFunction()
        this.unsubscribeChatFunction = null
      }
    },
    subscribeChatMessages () {
      this.unsubscribeChatMessages()
      this.unsubscribeChatFunction = fb.db.collection('chats')
        .doc(this.cast.chat_id)
        .collection('messages')
        .onSnapshot((messages: firebase.firestore.QuerySnapshot) => {
          if (this.messages.length) {
            this.messages.splice(0, this.messages.length)
          }
          messages.docs.forEach(message => {
            this.messages.push(message.data() as CastChatMessage)
          })
      }, error => {
        console.error('error subscribeChatMessages ' + this.cast.chat_id + ' ' + error)
      })
    },
    editCast () {
      this.$emit('editCast', this.cast)
    },
    copyCastOutputs () {
      this.$emit('copyOutputs', this.cast)
    },
    stopCast () {
      this.$store.direct.dispatch.logs.addLog({ message: 'Stop event modal shown', cast: this.cast.id, level: 'info' })
      this.$confirm('Are you sure you want to stop this event?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$emit('stopCast', this.cast)
        this.$store.direct.dispatch.logs.addLog({ message: 'Stop event initiated', cast: this.cast.id, level: 'info' })
      }).catch(() => {
        //
      })
    },
    copyCast () {
      this.$emit('copyCast', this.cast)
    },
    deleteCast () {
      this.$store.direct.dispatch.logs.addLog({ message: 'Delete event modal shown', cast: this.cast.id, level: 'info' })
      this.$confirm('Are you sure you want to delete this event?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$emit('deleteCast', this.cast)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
        this.$store.direct.dispatch.logs.addLog({ message: 'Delete event initiated', cast: this.cast.id, level: 'info' })
      }).catch(() => {
        //
      })
    },
    sendMessage (paramMessage) {
      if (this.cast) {
        const msg = {
          chat_id: this.cast.chat_id,
          msg: { message: paramMessage, user_id: this.currentUserId, timestamp: Date.now() }
        }
        this.$store.direct.dispatch.events.sendMessage(msg)
        this.$store.direct.dispatch.logs.addLog({ message: 'Message sent from in cast.', cast: this.cast.id, level: 'info' })
      }
    },
    addOutputVideo (vid) {
      this.$emit('addOutputVideo', vid)
    },
    downloadMP4 (mp4link) {
      window.open(mp4link, '_blank')
    },
    setAudioSource () {
      this.$emit('setAudioSource', this.cast.id)
    },
    formatDate (paramDate) {
      return moment.unix(paramDate).format('M/D/YYYY h:mm a')
    },
    requestCasterRepublish (caster) {
      this.$emit('requestCasterRepublish', { cast: this.cast.id, caster: caster })
    },
    bitrate (qualitystring, rate) {
      let videorate = Math.round(qualitystring.split('p')[1]) / 1000.0
      if (rate !== undefined && rate.video_bitrate !== undefined) {
        videorate = rate.video_bitrate / 1000.0
      }
      return videorate
    },
    getOutputStreamName (stream) {
      let name = stream.streamname
      name = name.charAt(0).toUpperCase() + name.slice(1)
      let existingFound = false
      Object.values(this.teamStreams).forEach(teamstream => {
        if (teamstream.srcurl === stream.url && teamstream.type === 'output') {
          if (teamstream.deleted === false) {
            name = teamstream.name
            existingFound = true
          } else if (!existingFound && teamstream.name !== undefined) {
            name = teamstream.name
          }
        }
      })
      return name
    },
    toggleStream (stream_data) {
      const stream_active = stream_data.streamActive
      const action = (stream_active ===  undefined || stream_active) ? 'pause' : 'resume'
      const action_value = (stream_active === undefined || stream_active) ? false : !stream_active
      const message_output = { 'pause': 'paused', 'resume': 'resumed'}
      this.$confirm('Are you sure you want to ' + action +  ' this output? ',
          'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.$store.direct.dispatch.events.toggleCastOutput({'castId':this.cast.id, 'streamId': stream_data.streamId, 'active': action_value})
          this.$store.direct.dispatch.logs.addLog({
          message: `User ' + action + ' output ${stream_data.streamId} from cast.`,
          cast: this.cast.id,
         level: 'info'
          })
          this.$message({
              type: 'success',
              message: 'Output ' + message_output[action]
            })
        }).catch(() => {
          //
        })
    },
    casterFeedNames (casterId, feedMap) {
      // find stream feednames (eg used by Librato Charts)
      // note: a single caster can have multiple streams (eg after reconnecting)
      const matches: string[] = []
      Object.keys(feedMap || {}).forEach(key => {
        if (feedMap[key] === casterId) {
          matches.push(key)
        }
      })
      return matches
    },
    streamFeedNames (streamId, stream: any) {
      const feedNames: string[] = []
      if (stream?.leftrightsplit) {
        const matchleft = findKey(this.cast.feedname || {}, val => val === `${streamId}_rtmpleft` )
        const matchright = findKey(this.cast.feedname || {}, val => val === `${streamId}_rtmpright` )
        if (matchleft) {
          feedNames.push(matchleft)
        }
        if (matchright) {
          feedNames.push(matchright)
        }

      } else {
        const match = findKey(this.cast.feedname || {}, val => val === streamId)
        if (match) {
          feedNames.push(match)
        }
      }

      return feedNames
    },
    copyInviteUrlToClipboard (): void {
      const href = this.getURL('liveEvent', { id: this.cast.id })
      const url = new URL(window.location.origin + href)
      url.searchParams.set('token', this.cast.token)

      if (!this.cast.token) {
        this.$message({ type: 'error', message: `Cast "${ this.cast.name }" does not have a token defined.` })
        return
      }

      const tmpInput = document.createElement('input') as HTMLInputElement
      tmpInput.setAttribute('style', 'position: absolute; left: -1000px; top: -1000px')
      tmpInput.value = url.href
      document.body.appendChild(tmpInput)
      tmpInput.select()
      document.execCommand('copy')
      tmpInput.blur()
      document.body.removeChild(tmpInput)

      this.$message({ type: 'success', message: `Copied URL of cast "${ this.cast.name }" to clipboard!` })
    },
    getEventName (): string {
      if (!this.cast.event_id) return ''
      const event = this.$store.direct.state.events.events.find(evt => evt.id === this.cast.event_id)
      return event?.name ?? ''
    }
  },
  components: {
    CasterStatus,
    CrewStatus,
    InputOutputStatus,
    ChatComponent,
    FinalOutputPlayer,
    QualityLabel,
    CastSupportBadge,
    CastEnvBadge,
    CastBadge,
    VideoPlaceholder,
    ClipMaker,
    ClipOverview,
    Modal,
    CreateEditCastTemplate,
    'el-popover': Popover,
    'el-button': Button
  }
})
